import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { FeedbackBaseFragmentDoc } from '../../fragments/__generated__/Feedback.generated';
import { ReflectionBaseFragmentDoc } from '../../fragments/__generated__/Reflection.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FeedbackListQueryVariables = Types.Exact<{
  offset: Types.Scalars['Int']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  score?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  scoreGt?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  scoreLt?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  marketplace?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  sortBy: Array<Types.FeedbackOrder> | Types.FeedbackOrder;
}>;


export type FeedbackListQuery = { feedbackList: { totalCount: number, pageInfo: { limit: number | null, offset: number }, results: Array<{ id: string, pk: number, title: string, comment: string, score: number, userName: string, timeCreated: any, url: string, product: { id: string, pk: number } | null, salesChannel: { id: string, pk: number, name: string }, siteSpecifics: { id: string, pk: number, name: string, shortName: string, videoUrl: string | null, slug: string } | null, line: { id: string, productName: string, product: { id: string, thumbnailUrl: string | null } | null } | null }> } };

export type ReviewLinkQueryVariables = Types.Exact<{
  token: Types.Scalars['String']['input'];
}>;


export type ReviewLinkQuery = { reviewLink: { productName: string, alreadyReviewed: boolean, product: { id: string, pk: number, name: string, thumbnailUrl: string | null } | null } | null };


export const FeedbackListDocument = gql`
    query FeedbackList($offset: Int!, $limit: Int, $score: Int, $scoreGt: Int, $scoreLt: Int, $marketplace: ID, $sortBy: [FeedbackOrder!]!) {
  feedbackList(
    pagination: {offset: $offset, limit: $limit}
    ordering: $sortBy
    filters: {score: {exact: $score, gt: $scoreGt, lt: $scoreLt}, salesChannel: $marketplace}
  ) {
    totalCount
    pageInfo {
      limit
      offset
    }
    results {
      ...FeedbackBaseFragment
      product {
        id
        pk
      }
      salesChannel {
        id
        pk
        name
      }
      siteSpecifics {
        ...ReflectionBaseFragment
      }
      line {
        id
        productName
        product {
          id
          thumbnailUrl(method: THUMBNAIL_WEBP, size: "600x0")
        }
      }
    }
  }
}
    ${FeedbackBaseFragmentDoc}
${ReflectionBaseFragmentDoc}`;

/**
 * __useFeedbackListQuery__
 *
 * To run a query within a React component, call `useFeedbackListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackListQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      score: // value for 'score'
 *      scoreGt: // value for 'scoreGt'
 *      scoreLt: // value for 'scoreLt'
 *      marketplace: // value for 'marketplace'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useFeedbackListQuery(baseOptions: Apollo.QueryHookOptions<FeedbackListQuery, FeedbackListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedbackListQuery, FeedbackListQueryVariables>(FeedbackListDocument, options);
      }
export function useFeedbackListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedbackListQuery, FeedbackListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedbackListQuery, FeedbackListQueryVariables>(FeedbackListDocument, options);
        }
export type FeedbackListQueryHookResult = ReturnType<typeof useFeedbackListQuery>;
export type FeedbackListLazyQueryHookResult = ReturnType<typeof useFeedbackListLazyQuery>;
export type FeedbackListQueryResult = Apollo.QueryResult<FeedbackListQuery, FeedbackListQueryVariables>;
export function refetchFeedbackListQuery(variables: FeedbackListQueryVariables) {
      return { query: FeedbackListDocument, variables: variables }
    }
export const ReviewLinkDocument = gql`
    query ReviewLink($token: String!) {
  reviewLink(token: $token) {
    productName
    alreadyReviewed
    product {
      id
      pk
      name
      thumbnailUrl(method: THUMBNAIL_WEBP, size: "600x0")
    }
  }
}
    `;

/**
 * __useReviewLinkQuery__
 *
 * To run a query within a React component, call `useReviewLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewLinkQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useReviewLinkQuery(baseOptions: Apollo.QueryHookOptions<ReviewLinkQuery, ReviewLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewLinkQuery, ReviewLinkQueryVariables>(ReviewLinkDocument, options);
      }
export function useReviewLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewLinkQuery, ReviewLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewLinkQuery, ReviewLinkQueryVariables>(ReviewLinkDocument, options);
        }
export type ReviewLinkQueryHookResult = ReturnType<typeof useReviewLinkQuery>;
export type ReviewLinkLazyQueryHookResult = ReturnType<typeof useReviewLinkLazyQuery>;
export type ReviewLinkQueryResult = Apollo.QueryResult<ReviewLinkQuery, ReviewLinkQueryVariables>;
export function refetchReviewLinkQuery(variables: ReviewLinkQueryVariables) {
      return { query: ReviewLinkDocument, variables: variables }
    }